import { useEffect, useState } from 'react';

const ImageRoulette = ({ images, alt, ...props }) => {
  const [image, setImage] = useState(images[0]);

  useEffect(() => {
    const changeImage = () => {
      setImage(images[Math.floor(Math.random() * images.length)]);
    };

    window.onload = function () {
      setInterval(changeImage, 400);
    };
  }, []);

  return (
    <img alt={alt} src={image} {...props} />
  );
};

export default ImageRoulette;
